export default __webpack_public_path__ + "static/media/birdicon.7609b308.png";